import { For } from "solid-js";
import type { PieceTypeId, PlayerId } from "../../core";
import { PieceIcon } from "./PieceIcon";

interface Placed {
  readonly file: number;
  readonly rank: number;
  readonly type: PieceTypeId;
  readonly owner: PlayerId;
}

// A decorative mid-game snapshot — the Lichess-style board anchor on the home
// page. Purely cosmetic; not a live game.
const POSITION: readonly Placed[] = [
  // White (bottom)
  { file: 4, rank: 0, type: "king", owner: 0 },
  { file: 3, rank: 0, type: "prince", owner: 0 },
  { file: 2, rank: 1, type: "pawn", owner: 0 },
  { file: 5, rank: 1, type: "pawn", owner: 0 },
  { file: 4, rank: 1, type: "lance", owner: 0 },
  { file: 3, rank: 2, type: "knight", owner: 0 },
  { file: 6, rank: 3, type: "bishop", owner: 0 },
  { file: 1, rank: 2, type: "rook", owner: 0 },
  // Black (top)
  { file: 4, rank: 7, type: "king", owner: 1 },
  { file: 3, rank: 7, type: "prince", owner: 1 },
  { file: 2, rank: 6, type: "pawn", owner: 1 },
  { file: 5, rank: 6, type: "pawn", owner: 1 },
  { file: 4, rank: 5, type: "knight", owner: 1 },
  { file: 1, rank: 4, type: "rook", owner: 1 },
  { file: 6, rank: 6, type: "bishop", owner: 1 },
  { file: 7, rank: 4, type: "queen", owner: 1 },
];

export function LobbyBoard() {
  const cells: { file: number; rank: number }[] = [];
  for (let rank = 7; rank >= 0; rank--) {
    for (let file = 0; file < 8; file++) cells.push({ file, rank });
  }
  const at = (file: number, rank: number) =>
    POSITION.find((p) => p.file === file && p.rank === rank);

  return (
    <div class="lobby-board" aria-hidden="true">
      <For each={cells}>
        {(c) => {
          const light = (c.file + c.rank) % 2 === 1;
          const p = at(c.file, c.rank);
          return (
            <div class="cell" classList={{ light, dark: !light }}>
              {p ? <PieceIcon type={p.type} owner={p.owner} /> : null}
            </div>
          );
        }}
      </For>
    </div>
  );
}
